<p-dialog id="dlgLogOut"
    class="modal-logout" 
    styleClass="{{dialogTemplate.styleClass}}"
    [showHeader]="true"
    [styleClass]="'modal-content'"
    [style]="dialogTemplate.style"
    [(visible)]="isDisplayModal" [modal]="dialogTemplate.isModal" 
    [breakpoints]="dialogTemplate.breakpoints" [style]="dialogTemplate.style"
    [dismissableMask]="dialogTemplate.isDismissableMask"
    (onHide)="closeModal(false)">
        <div class="modal-body" [attr.dpad] = "DpadZoneType.DIALOG" [attr.x-dpad] = "0"  [attr.y-dpad] = "0"  (click)="closeModal(true)">
            <div class="logout-img"></div>
            <label class="lbl-logout">{{LOGOUT.LBL_LOGOUT}}</label>
        </div>
</p-dialog>